export const defaultConfig = {
    NODE_ENV: null,
    REACT_APP_COLBI_THEME: "sovos",
    PUBLIC_URL: null,
    REACT_APP_PROXY_HOST: "",
    REACT_APP_SSO_BASE_URL: "https://account-dev.sovos.com/",
    REACT_APP_SSO_CLIENT_ID: "",
    REACT_APP_SSO_ID_ISSUER: "",
    REACT_APP_AUTH_MODE: "SSO",
    REACT_APP_SSO_REDIRECT_URI: `http://localhost:3000/v1/oidc/uri_callback`,
    REACT_APP_SAML_CLIENT_ID: "p__gvat-aprsaft-saml-dev",
    REACT_APP_SAML_REDIRECT_URI: `http://localhost:3000/v1/saml/uri_callback`,
    REACT_APP_SAML_BASE_URL: "https://dev.identity.sovos.com",
    REACT_APP_ENVIRONMENT_TYPE: "dev",
    REACT_APP_LEARN_MORE_URL: "https://sovos.com/vat/products/saf-t/",
    REACT_APP_PRIVACY_POLICY_URL: "https://sovos.com/privacy-policy/",
    REACT_APP_TERMS_AND_CONDITIONS_URL: "https://sovos.com/software-and-services-terms/",
    REACT_APP_DEFAULT_PAGE_SIZE: "20",
    REACT_APP_AI_API_BASE: "https://sovi-api.dev.sovos.com/ai/",
    REACT_APP_DOCS_API_ENDPOINT: "https://api-internal.sovos.com/v1/internal/docs/structure?audience=sovos-internal",
};

export const buildAuthConfig = (envVariables) => {
    return {
        sso: {
            authority: `${envVariables.REACT_APP_SSO_BASE_URL}`,
            issuer: `${envVariables.REACT_APP_SSO_BASE_URL}`,
            authorization_endpoint: `${envVariables.REACT_APP_SSO_BASE_URL}/api/oauth/authorize`,
            token_endpoint: `${envVariables.REACT_APP_SSO_BASE_URL}/api/oauth/token`,
            jwks_uri: `${envVariables.REACT_APP_SSO_BASE_URL}/.well-known/jwks`,
            client_id: envVariables.REACT_APP_SSO_CLIENT_ID,
            redirect_uri: envVariables.REACT_APP_SSO_REDIRECT_URI,
            post_logout_redirect_uri: envVariables.REACT_APP_SSO_REDIRECT_URI,
            response_type: "code",
        },
        saml: {
            post_logout_redirect_uri: envVariables.REACT_APP_SAML_REDIRECT_URI,
            authority: envVariables.REACT_APP_SAML_BASE_URL,
            client_id: envVariables.REACT_APP_SAML_CLIENT_ID,
            redirect_uri: envVariables.REACT_APP_SAML_REDIRECT_URI,
            issuer: `${envVariables.REACT_APP_SAML_BASE_URL}`,
            authorization_endpoint: `${envVariables.REACT_APP_SAML_BASE_URL}/api/oauth/authorize`,
            token_endpoint: `${envVariables.REACT_APP_SAML_BASE_URL}/api/oauth/token`,
            jwks_uri: `${envVariables.REACT_APP_SAML_BASE_URL}/pf/JWKS`,
            end_session_endpoint: `${envVariables.REACT_APP_SAML_BASE_URL}/idp/startSLO.ping`,
            response_type: "code",
            metadata: {
                end_session_endpoint: `${envVariables.REACT_APP_SAML_BASE_URL}/idp/startSLO.ping`,
                issuer: envVariables.REACT_APP_SAML_BASE_URL,
                authorization_endpoint: `${envVariables.REACT_APP_SAML_BASE_URL}/as/authorization.oauth2`,
                token_endpoint: `${envVariables.REACT_APP_SAML_BASE_URL}/as/token.oauth2`,
            },
        },
    };
};

export const globalConfig = { config: { ...defaultConfig } };

export const globalConfigUrl = "/config.json";

export function getConfigVariable(variableName) {
    if (window.saftEnvVariables) {
        return window.saftEnvVariables[variableName];
    }
    return undefined;
}

export async function loadConfig() {
    const globalVariables = `${process.env.NODE_ENV}`.toLowerCase() === 'development'
        ? { ...process.env }
        : await fetch(globalConfigUrl).then(res => res.json())

    globalConfig.config = {
        ...defaultConfig,
        ...globalVariables,
        AUTH_CONFIG: buildAuthConfig({ ...defaultConfig, ...globalVariables })
    };

    return globalConfig.config;
}